var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "" + (_vm.shouldClip ? "clipped" : "") },
    [
      _vm._l(_vm.parts, function (part, index) {
        return [
          part.highlighted
            ? [
                _c("span", { key: index, staticClass: "highlighted" }, [
                  _vm._v(_vm._s(part.text)),
                ]),
              ]
            : [_vm._v("\n            " + _vm._s(part.text) + "\n        ")],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }